import { Dropdown, MenuProps, Row } from "antd";
import { useMemo } from "react";
import { UserOutlined, DownOutlined, LogoutOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import ROUTES from "../../../../configs/routesConfig";

type MobileMenuProps = {
  onLogoutClicked: () => void;
};

export const MobileMenu = ({ onLogoutClicked }: MobileMenuProps) => {
  const items: MenuProps["items"] = useMemo(() => {
    return [
      {
        key: "1",
        label: (
          <Row className="w-100 align-center">
            <Link to={ROUTES.PROFILE} className="w-100">
              <UserOutlined className="mr-1" />
              Profile
            </Link>
          </Row>
        ),
      },
      {
        type: "divider",
      },
      {
        key: "2",
        label: (
          <Row className="w-100 align-center" onClick={onLogoutClicked}>
            <LogoutOutlined className="mr-1" />
            Log out
          </Row>
        ),
      },
    ];
  }, [onLogoutClicked]);

  return (
    <Dropdown
      menu={{ items }}
      trigger={["click"]}
      className="header-button px-4 mobile-btn align-center"
      overlayClassName="mobile-menu"
    >
      <Row>
        <UserOutlined className="mr-1" />
        <DownOutlined />
      </Row>
    </Dropdown>
  );
};
